export default "__VITE_ASSET__FiLCvisj__"